import { css } from "@emotion/css"

import Footer from "./Footer/Footer"
import Header from "./Header/Header"
import AnswerChan from "./Inquiry/answerChan/AnswerChan"
import ReferFriendsCouponBannerWide from "./ReferFriendsCouponBannerWide/ReferFriendsCouponBannerWide"
import SideBar from "./SideBar/SideBar"

type Props = {
  children?: React.ReactNode
  layout?: "simple" | "full"
}

const MyPageLayout = ({ children, layout = "full" }: Props) => {
  const isFullLayout = layout === "full"

  return (
    <div className={styles.body}>
      <Header />
      <div className={styles.content}>
        <div className={styles.flexContainer}>
          {isFullLayout && <SideBar />}
          <main className={styles.main}>{children}</main>
        </div>
        {isFullLayout && (
          <div className={styles.banner}>
            <ReferFriendsCouponBannerWide />
          </div>
        )}
      </div>
      <Footer />
      <AnswerChan />
    </div>
  )
}

export default MyPageLayout

const styles = {
  body: css`
    display: flex;
    flex-direction: column;
    min-width: 1180px;
    min-height: 100vh;
  `,
  content: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    min-height: 680px;
    padding: 30px;
    padding-bottom: 140px;
    * {
      scroll-margin-top: 60px;
    }
  `,
  flexContainer: css`
    display: flex;
    column-gap: 30px;
    justify-content: center;
  `,
  main: css`
    width: 740px;
  `,
  banner: css`
    width: 970px;
    padding-top: 40px;
    padding-left: 235px;
  `,
}
